module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[86]85.fe8d7eb.woff2";